import React, { Component } from "react";
import { connect } from "react-redux";
import logo from "./logo.png";
import "./style.scss";

class BlankPage extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <div className="blank-page">
        <img src={logo} />
      </div>
    );
  }
}

export default connect()(BlankPage);



// WEBPACK FOOTER //
// ./src/routes/blank/index.js